import { render } from "./PersonReport.vue?vue&type=template&id=0cb9087a&scoped=true"
import script from "./PersonReport.vue?vue&type=script&lang=js"
export * from "./PersonReport.vue?vue&type=script&lang=js"

import "./PersonReport.vue?vue&type=style&index=0&id=0cb9087a&scoped=true&lang=css"

import exportComponent from "/var/www/html/dongan_teens2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb9087a"]])

export default __exports__